export const h = {
    "common": {
        "webSuffix": "- QIDI Tech",
        "email": "postaláda",
        "password": "jelszó",
        "verificationCode": "Ellenőrzési kód",
        "username": "felhasználónév",
        "readAndAgree": "Egyetértek",
        "and": "és",
        "userAgreement": "Felhasználói megállapodás",
        "privacyPolicy": "Adatvédelmi nyilatkozat",
        "copy": "szerzői jog ©  2025-től kezdődően a Di tartalék tulajdonjoga",
        "sendVerificationCode": "Ellenőrző kód küldése",
        "Sending": "Küldés",
        "tryAgainInSeconds": "Próbáld meg újra másodperceken belül",
        "userNameRequired": "adjon meg egy felhasználónevet",
        "passwordInputLabel": "Adjon meg egy jelszót",
        "checkPasswordInputLabel": "Kérjük, adja meg a visszaigazoló jelszót",
        "userEmailRequired": "Kérjük, adja meg e-mail címét",
        "userEmailInvalid": "Kérjük, adja meg a megfelelő e-mail címet",
        "emailCodeRequired": "Kérjük, adja meg az ellenőrző kódot",
        "newPasswordInputLabel": "Adjon meg egy új jelszót",
        "confirmPasswordInputLabel": "Kérjük, adja meg újra a jelszavát",
        "passwordMismatchErrorLabel": "A kétszer megadott jelszó következetlen",
        "agreementRequired": "Kérjük, olvassa el és fogadja el a megállapodást",
        "tip": "Tippek",
        "tipAlreadyLogin": "Észlelte, hogy bejelentkezett, átirányította a felhasználói központba",
        "tipWelcomeBack": "Üdvözlöm újra!",
        "tipDeleteAccountFail": "A fiók törlése nem sikerült, a fiók törlési felülete ideiglenesen lezárva van",
        "pleaseAgreeFirst": "Kérem, először egyetértsenek.",
        "agree": "egyetértés",
        "refuse": "elutasítani",
        "tipNeedLogin": "Először jelentkezzen be.",
        "tipChangePasswordSuccess": "A jelszó sikeresen megváltozott, átirányítjuk Önt a bejelentkezési oldalra",
        "tipGetUserInfoSuccess": "Sikeresen beszerzett információk",
        "tipGetUserInfoFail": "információk meghibásodása",
        "tipLoginOut": "Jelentkezzen ki és jelentkezzen be",
        "delete": "törlés",
        "back": "visszatérés",
        "init": "inicializálás",

        "passwordInputLengthErrorLabel": "A jelszó hosszának 6 és 20 között kell lennie.",
        "changePasswordFail": "Az eredeti jelszó helytelen",
        "tipDeleteAccountSuccess": "A fiók törlése sikeresen",
        "emailCodeSentSuccess": "Az ellenőrzési kódot kiállították",
        "emailCodeSentFail": "Az ellenőrzési kód kibocsátása nem sikerült",
        "emailLoginFail": "Az ellenőrző kód lejárt.",
        "passwordLoginFail": "Helytelen bejelentkezési jelszó",
        "editUserInfoSuccess": "Sikeresen módosított felhasználói információk",
        "registerSuccess": "Sikeresen regisztrált",
        "registerFail": "nem sikerült bejelentkezni",
        "registerEmailExistFail": "E-mail már létezik",

        "resMessageTip0": "ismeretlen információ",
        "resMessageTip1": "Jelszóhiba",
        "resMessageTip2": "A jelszó hosszának 6 és 20 között kell lennie.",
        "resMessageTip3": "Számlahiba",
        "resMessageTip4": "Az ellenőrzési kódot kiállították",
        "resMessageTip5": "Az ellenőrzési kód kibocsátása nem sikerült",
        "resMessageTip6": "Az ellenőrző kód lejárt.",
        "resMessageTip7": "Jelszóhiba",
        "resMessageTip8": "A jelszó nem lehet azonos a régi jelszóval",
        "resMessageTip9": "E-mail már létezik",
        "resMessageTip10": "Sikeresen regisztrált",
        "resMessageTip11": "nem sikerült bejelentkezni",
        "resMessageTip12": "Sikeresen módosított felhasználói információk",
        "resMessageTip13": "Nem sikerült módosítani a felhasználói adatokat",
        "resMessageTip14": "Sikeresen elért",
        "resMessageTip15": "Beszerzés sikertelen",
        "resMessageTip16": "A jelszó sikeresen megváltozott",
        "resMessageTip17": "A jelszó módosítása nem sikerült",
        "resMessageTip18": "A jelszó visszaállítása sikeres",
        "resMessageTip19": "A jelszó visszaállítása nem sikerült",
        "resMessageTip20": "Bejelentkezés sikeres",
        "resMessageTip21": "Bejelentkezés sikertelen",
        "resMessageTip22": "A fiók törlése sikeresen",
        "resMessageTip23": "Nem sikerült törölni a fiókot",
        "resMessageTip24": "Az ellenőrző kód helytelen",
        "noUserInfoError": "Hálózati hiba, kérjük jelentkezzen be újra"
    },
    "changePassword": {
        "newPassword": "Új jelszó"
    },
    "deleteUser": {
        "tipDeleteUser": "Sajnos el kell menned. Miután törölték fiókját, minden személyes adata véglegesen eltűnik, és nem helyreállítható.",
        "accountDeletionTerms": "Számlatörlési feltételek"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Jelszó lekérése e-mailben",
        "confirmPassword": "Jelszó megerősítése",
        "resettingPassword": "jelszó visszaállítása",
        "resetting": "Visszaállítás"
    },
    "login": {
        "passwordLogin": "Jelszó bejelentkezése",
        "verifyLogin": "A bejelentkezés ellenőrzése",
        "accountRegistration": "Számlanyilvántartás",
        "forgotPassword": "Elfelejtett jelszó",
        "login": "Bejelentkezés",
        "localLogin": "Helyi bejelentkezés",
        "loginOut": "Kijelentkezés",
        "continueOnYourWay": "Folytasd az utad"
    },
    "register": {
        "registerAnAccount": "Fiók regisztrálása",
        "register": "nyilvántartás"
    },
    "userCenter": {
        "personalInformation": "személyes adatok",
        "modifyInformation": "Az információ módosítása",
        "changePassword": "Jelszó módosítása",
        "cancelAccount": "Fiók törlése",
        "exitAccount": "Kilépési számla",
        "change": "módosítás",
        "maxCharLimitTip": "A felhasználónév hossza nem haladhatja meg a 10 kínai karaktert",
    },
    "policies": {
        "deleteAccountPrivacy": "Fiók törlése",
        "agreement": "Használati megállapodás",
        "privacyPolicy": "Adatvédelmi nyilatkozat"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Válassza ki az Ön országát vagy régióját",
        "recommendedVisits": "Ajánlott látogatás",
        "NorthAmerica": "Észak-Amerika",
        "Europe": "Európa",
        "Asia": "Ázsia",
        "Other": "egyéb",
    }
}

export const aAndL ={
    "ar": {
        "Country": "arab",
        "Language": "Arab"
    },
    "cs": {
        "Country": "Cseh Köztársaság",
        "Language": "Cseh"
    },
    "de": {
        "Country": "Németország",
        "Language": "Német"
    },
    "en": {
        "Country": "brit",
        "Language": "Angol"
    },
    "es": {
        "Country": "Spanyolország",
        "Language": "Spanyol"
    },
    "fr": {
        "Country": "Franciaország",
        "Language": "Francia"
    },
    "he": {
        "Country": "Izrael",
        "Language": "Héber"
    },
    "hu": {
        "Country": "Magyarország",
        "Language": "Magyar nyelv"
    },
    "it": {
        "Country": "Olaszország",
        "Language": "Olasz"
    },
    "ja": {
        "Country": "Japán",
        "Language": "Japán"
    },
    "ko": {
        "Country": "a Koreai Köztársaság",
        "Language": "Koreai"
    },
    "nl": {
        "Country": "Hollandia",
        "Language": "Hollandia"
    },
    "pt": {
        "Country": "Portugália",
        "Language": "Portugál"
    },
    "pt_BR": {
        "Country": "Portugália (Brazília)",
        "Language": "Portugál (Brazília)"
    },
    "ru": {
        "Country": "Oroszország",
        "Language": "Orosz"
    },
    "sv": {
        "Country": "Svédország",
        "Language": "Svéd nyelv"
    },
    "tr": {
        "Country": "Türkiye",
        "Language": "Török"
    },
    "uk": {
        "Country": "Ukrajna",
        "Language": "Ukrán nyelv"
    },
    "zh": {
        "Country": "Kínai szárazföld",
        "Language": "Egyszerűsített kínai"
    },
    "zh_tw": {
        "Country": "Tajvan, Kína",
        "Language": "Hagyományos kínai"
    },
    "Canada": {
        "Country": "Kanada",
        "Language": "Angol"
    },
    "United_States": {
        "Country": "USA",
        "Language": "Angol"
    },
    "United_Kingdom": {
        "Country": "brit",
        "Language": "Angol"
    },
    "EU_Countries": {
        "Country": "EU-országok",
        "Language": "Angol"
    },
    "Australia": {
        "Country": "Ausztrália",
        "Language": "Angol"
    },
    "globalzh": {
        "Country": "Globális",
        "Language": "Egyszerűsített kínai"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Angol"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/hu.js